<template>
    <div class="page have-menu no-bg">
        <div class="bg-fixed bg-splus"></div>
        <div class="page-content">
            <TopBar></TopBar>
            <div class="pt-5 px-3">
                <HistoryList
                    ref="history-list"
                    :initListConfig="purchaseListConfig"
                    :initFilterConfig="purchaseFilterListConfig"
                    :isReward="true"
                    :modalController="modalController"
                ></HistoryList>
            </div>
            <MenuBar :modalController="modalController"></MenuBar>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import HistoryList from '../component/HistoryList.vue';
import MenuBar from "@/components/Layout/MenuBar/MenuBar.vue";
//service
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
} from '@/core/History/config/HistoryConfigModel.js';
//mixin
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: 'HistoryReward',
    mixins: [ModalMixin, AuthPageMixin, LocaleMixin],
    components: {
        TopBar,
        HistoryList,
        MenuBar,
    },
    data: function() {
        return {
            purchaseListConfig: null,
            purchaseFilterListConfig: null,
        };
    },
    created: function() {
        this.setScrollLoadMore();
        this.Init();
        this.tracking.screenName('reward');
        this.tracking.event('reward', 'view_reward');
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        //#region mixin
        onSetupModalCompleted: function() {
            this.initialHistoryModal();
        },
        //#endregion mixin
        Init: function () {
            this.loadingModal.show();
            this.setupHistoryList();
            this.loadingModal.hide();
        },
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                let scrollOffSet = 100;
                let pageHeight = Math.max(
                    window.scrollY,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                let bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        setupHistoryList: async function () {
            //initial config for api.
            let listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryRewardList())
                .setTop(25)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            let filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.purchaseFilterListConfig = filterListConfig;
        },

        loadMore: async function() {
            await this.$refs['history-list'].loadMore();
        },
    },
}
</script>
